export default {
  intl: 'https://www.instagram.com/nuinalp',
  'pt-br': 'https://www.instagram.com/nuinalp',
} as const;
